// Configuration
const parametersToCapture = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "src", "lh_cpt", "gclid", "p", "irclickid", "irgwc", "utm_id"];
const cacheLifetimeInMinutes = 43200;


const windowSearchParameters = new URL(window.location).searchParams;
const timestamp = parseInt(window.localStorage.getItem("lvhn-parameters-timestamp")) ?? 0;
const filteredParameters = [...windowSearchParameters].filter(([key]) => parametersToCapture.includes(key));
let capturedParameters;

// Cache is cleared if new data is captured or cache expires
const cacheLifetimeInMS = cacheLifetimeInMinutes * 60 * 1000;
if (Date.now() > timestamp + cacheLifetimeInMS || filteredParameters.length) {
  console.debug("Refreshing query parameter cache");
  capturedParameters = new Map();
  window.localStorage.setItem("lvhn-parameters-timestamp", Date.now());
} else {
  capturedParameters = new Map(JSON.parse(window.localStorage.getItem("lvhn-parameters")));
  console.debug("Loading query parameter cache");
}

for (const [key, value] of filteredParameters) {
  capturedParameters.set(key, value);
}

window.localStorage.setItem("lvhn-parameters", JSON.stringify([...capturedParameters]));

function linkHandler(event) {
  const link = event.target.closest("a");
  if (!link) return;

  const linkTarget = new URL(link.href);
  if (!linkTarget.host.includes("amorana.ch")) return;

  const linkParameters = new URLSearchParams(linkTarget.search);
  for (const [key, value] of capturedParameters) {
    linkParameters.set(key, value);
  }

  linkParameters.set("lhnp", window.location.pathname);
  linkParameters.set("lhnc", localStorage.getItem("lvhn-UUID"));

  linkTarget.search = linkParameters;
  link.href = linkTarget;
}

function formHandler(event) {
  const form = event.target;
  if (!form.action.includes("amorana.ch")) return;

  for (const [key, value] of capturedParameters) {
    const parameter = document.createElement("input");
    parameter.type = "hidden";
    parameter.name = key;
    parameter.value = value;
    form.append(parameter);
  }


    const lhnpParameter = document.createElement("input");
    lhnpParameter.type = "hidden";
    lhnpParameter.name = "lhnp";
    lhnpParameter.value = window.location.pathname;
    form.append(lhnpParameter);

    const lhncParameter = document.createElement("input");
    lhncParameter.type = "hidden";
    lhncParameter.name = "lhnc";
    lhncParameter.value = localStorage.getItem("lvhn-UUID");
    form.append(lhncParameter);
}

document.addEventListener("click", linkHandler );
document.addEventListener("contextmenu", linkHandler);
document.addEventListener("auxclick", linkHandler);
document.addEventListener("submit", formHandler);